import path from 'ramda/src/path';
import { convertUnit } from 'invision-core/src/utilities/unitConversion';
import { NA } from '../constants/billing.payments.constants';
export function getUnitOfMeasure(unitId, units) {
  return path(['AdditionalProperties', 'short_name'], units.find(function (unit) {
    return unit.Value === unitId;
  }));
}
export function convertUnitOfMeasure(value, from, to, unitConversionTable) {
  var returnValue = value;
  var convertedBalance = convertUnit({
    to: to,
    from: from,
    value: value,
    unitConversionTable: unitConversionTable
  });
  if (convertedBalance) {
    returnValue = convertedBalance;
  }
  return returnValue || NA;
}